export const autEn = {
  'dat.aut.eyebrow': 'Catalogue',
  'dat.aut.title': 'Authorities',
  'dat.aut.description': 'Controlled headings for names, subjects and titles. Linked records stay consistent when a heading changes.',
  'dat.aut.back': 'All authorities',
  'dat.aut.heading': 'Authority heading',
  'dat.aut.allTypes': 'All types',
  'dat.aut.typeFilter': 'Filter by authority type',
  'dat.aut.search': 'Search headings and see-from terms',
  'dat.aut.usedFilter': 'Usage filter',
  'dat.aut.usedAll': 'Used and unused',
  'dat.aut.usedUsed': 'Linked to records',
  'dat.aut.usedUnused': 'Not used',
  'dat.aut.col.heading': 'Heading',
  'dat.aut.col.type': 'Type',
  'dat.aut.col.seeFrom': 'See from',
  'dat.aut.col.seeAlso': 'See also',
  'dat.aut.col.records': 'Records',
  'dat.aut.unused': 'Unused',
  'dat.aut.emptyTitle': 'No authorities yet',
  'dat.aut.emptyDesc': 'Create a heading by hand, or run auto-link to build authorities from the headings already in your records.',
  'dat.aut.emptyFilteredTitle': 'No authorities match',
  'dat.aut.emptyFilteredDesc': 'Try a different search term or clear the filters.',
  'dat.aut.seeFrom': 'See from',
  'dat.aut.seeAlso': 'See also',
  'dat.aut.seeFromHelp': 'Variant forms that lead readers to this heading.',
  'dat.aut.seeAlsoHelp': 'Related headings worth checking.',
  'dat.aut.note': 'Note',
  'dat.aut.noneYet': 'None yet.',
  'dat.aut.unsaved': 'You have unsaved changes to the references.',
  'dat.aut.saved': 'Authority saved',
  'dat.aut.created': 'Created "{heading}"',
  'dat.aut.deleted': 'Authority deleted',
  'dat.aut.meta': 'Linked to {used} records. Updated {updated}.',
  'dat.aut.notFound': 'Authority not found',
  'dat.aut.notFoundDesc': 'It may have been merged into another heading or deleted.',
  'dat.aut.loadFailed': 'We could not load this authority',
  'dat.aut.marcTitle': 'MARC authority record',
  'dat.aut.marcDesc': 'The 1XX heading with 4XX see-from and 5XX see-also tracings.',
  'dat.aut.chip.remove': 'Remove {value}',
  'dat.aut.create.open': 'New authority',
  'dat.aut.create.title': 'New authority',
  'dat.aut.create.description': 'Add a controlled heading with its variant forms.',
  'dat.aut.create.submit': 'Create authority',
  'dat.aut.edit.title': 'Edit authority',
  'dat.aut.edit.description': 'A changed heading is updated in every linked record.',
  'dat.aut.form.type': 'Authority type',
  'dat.aut.form.typePlaceholder': 'Choose a type',
  'dat.aut.form.typeRequired': 'Choose an authority type.',
  'dat.aut.form.heading': 'Heading',
  'dat.aut.form.headingHint': 'For example "Tagore, Rabindranath, 1861-1941".',
  'dat.aut.form.headingRequired': 'Enter the heading.',
  'dat.aut.form.headingLong': 'Headings can be at most 500 characters.',
  'dat.aut.form.chipsHint': 'Press Enter or semicolon to add each value.',
  'dat.aut.form.seeFromPlaceholder': 'Add a variant form',
  'dat.aut.form.seeAlsoPlaceholder': 'Add a related heading',
  'dat.aut.delete.title': 'Delete this authority?',
  'dat.aut.delete.desc': '"{heading}" will be removed. No records use it.',
  'dat.aut.delete.usedTitle': 'This authority is used by {count} records',
  'dat.aut.delete.usedDesc': 'Deleting it removes the link from every record. The headings in those records stay as text.',
  'dat.aut.delete.force': 'Delete anyway',
  'dat.aut.linked.heading': 'Linked bibliographic records',
  'dat.aut.linked.description': '{count} links to catalogue records.',
  'dat.aut.linked.title': 'Title',
  'dat.aut.linked.author': 'Author',
  'dat.aut.linked.field': 'Field',
  'dat.aut.linked.id': 'Record id',
  'dat.aut.linked.emptyTitle': 'No linked records',
  'dat.aut.linked.emptyDesc': 'Records link here when their heading matches or when you pick this authority in the catalogue editor.',
  'dat.aut.linked.unlink': 'Unlink {title}',
  'dat.aut.linked.unlinkShort': 'Unlink',
  'dat.aut.linked.unlinked': 'Record unlinked',
  'dat.aut.linked.confirmTitle': 'Unlink this record?',
  'dat.aut.linked.confirmDesc': 'The {tag} heading in "{title}" will no longer point to this authority.',
  'dat.aut.merge.open': 'Merge selected',
  'dat.aut.merge.pickTwo': 'Select 2 or more to merge',
  'dat.aut.merge.title': 'Merge authorities',
  'dat.aut.merge.description': 'Combine duplicate headings into one. All linked records move to the surviving heading.',
  'dat.aut.merge.stepSurvivor': 'Survivor',
  'dat.aut.merge.stepPreview': 'Review',
  'dat.aut.merge.stepDone': 'Done',
  'dat.aut.merge.pickLegend': 'Which heading should survive?',
  'dat.aut.merge.linked': '{count} records',
  'dat.aut.merge.seeFromCount': '{count} see-from',
  'dat.aut.merge.review': 'Review merge',
  'dat.aut.merge.confirm': 'Merge {count} authorities',
  'dat.aut.merge.survivor': 'Surviving heading',
  'dat.aut.merge.willAbsorb': 'Headings to absorb: {count}',
  'dat.aut.merge.willRelink': 'Record links to move',
  'dat.aut.merge.resultingSeeFrom': 'The survivor will gain these see-from references',
  'dat.aut.merge.irreversible': 'Merging cannot be undone. The absorbed authorities are deleted.',
  'dat.aut.merge.doneTitle': 'Authorities merged',
  'dat.aut.merge.statMerged': 'Merged',
  'dat.aut.merge.statRelinked': 'Links moved',
  'dat.aut.merge.statRecords': 'Records updated',
  'dat.aut.merge.openSurvivor': 'Open the surviving authority',
  'dat.aut.cleanup.open': 'Clean up',
  'dat.aut.cleanup.title': 'Clean up unused authorities',
  'dat.aut.cleanup.description': 'Remove authorities that no catalogue record links to.',
  'dat.aut.cleanup.intro': 'Run a preview first. Nothing is deleted until you apply the clean-up.',
  'dat.aut.cleanup.preview': 'Preview',
  'dat.aut.cleanup.apply': 'Delete {count} unused',
  'dat.aut.cleanup.none': 'Every authority is linked to at least one record. Nothing to clean up.',
  'dat.aut.cleanup.found': '{count} unused authorities found',
  'dat.aut.cleanup.foundHint': 'These will be deleted permanently when you apply the clean-up.',
  'dat.aut.cleanup.done': 'Deleted {count} unused authorities',
  'dat.aut.autolink.open': 'Auto-link',
  'dat.aut.autolink.title': 'Auto-link headings',
  'dat.aut.autolink.description': 'Match record headings to authorities, creating authorities for new headings.',
  'dat.aut.autolink.intro': 'This scans every catalogue record and may take a moment on a large catalogue.',
  'dat.aut.autolink.running': 'Linking headings. Keep this window open.',
  'dat.aut.autolink.run': 'Run auto-link',
  'dat.aut.autolink.again': 'Run again',
  'dat.aut.autolink.processed': 'Records scanned',
  'dat.aut.autolink.linked': 'Links made',
  'dat.aut.autolink.created': 'Authorities created',
  'dat.aut.picker.label': 'Authority suggestions',
  'dat.aut.picker.searching': 'Searching',
  'dat.aut.picker.failed': 'Could not load suggestions. You can still type the heading.',
  'dat.aut.picker.none': 'No matching authority. The text you typed will be used as it is.',
} as const;

export const autHi: Record<keyof typeof autEn, string> = {
  'dat.aut.eyebrow': 'सूची',
  'dat.aut.title': 'प्राधिकार',
  'dat.aut.description': 'नामों, विषयों और शीर्षकों के नियंत्रित शीर्षक। शीर्षक बदलने पर जुड़े रिकॉर्ड एकरूप रहते हैं।',
  'dat.aut.back': 'सभी प्राधिकार',
  'dat.aut.heading': 'प्राधिकार शीर्षक',
  'dat.aut.allTypes': 'सभी प्रकार',
  'dat.aut.typeFilter': 'प्राधिकार प्रकार से फ़िल्टर करें',
  'dat.aut.search': 'शीर्षक और देखें-से शब्द खोजें',
  'dat.aut.usedFilter': 'उपयोग फ़िल्टर',
  'dat.aut.usedAll': 'उपयोग में और अनुपयोगी',
  'dat.aut.usedUsed': 'रिकॉर्ड से जुड़े',
  'dat.aut.usedUnused': 'अनुपयोगी',
  'dat.aut.col.heading': 'शीर्षक',
  'dat.aut.col.type': 'प्रकार',
  'dat.aut.col.seeFrom': 'देखें-से',
  'dat.aut.col.seeAlso': 'यह भी देखें',
  'dat.aut.col.records': 'रिकॉर्ड',
  'dat.aut.unused': 'अनुपयोगी',
  'dat.aut.emptyTitle': 'अभी कोई प्राधिकार नहीं',
  'dat.aut.emptyDesc': 'हाथ से शीर्षक बनाएँ, या ऑटो-लिंक चलाकर रिकॉर्ड के मौजूदा शीर्षकों से प्राधिकार बनाएँ।',
  'dat.aut.emptyFilteredTitle': 'कोई प्राधिकार मेल नहीं खाता',
  'dat.aut.emptyFilteredDesc': 'कोई दूसरा खोज शब्द आज़माएँ या फ़िल्टर हटाएँ।',
  'dat.aut.seeFrom': 'देखें-से',
  'dat.aut.seeAlso': 'यह भी देखें',
  'dat.aut.seeFromHelp': 'वैकल्पिक रूप जो पाठकों को इस शीर्षक तक पहुँचाते हैं।',
  'dat.aut.seeAlsoHelp': 'संबंधित शीर्षक जो देखने योग्य हैं।',
  'dat.aut.note': 'टिप्पणी',
  'dat.aut.noneYet': 'अभी कोई नहीं।',
  'dat.aut.unsaved': 'संदर्भों में आपके बदलाव सहेजे नहीं गए हैं।',
  'dat.aut.saved': 'प्राधिकार सहेजा गया',
  'dat.aut.created': '"{heading}" बनाया गया',
  'dat.aut.deleted': 'प्राधिकार हटाया गया',
  'dat.aut.meta': '{used} रिकॉर्ड से जुड़ा। अद्यतन {updated}।',
  'dat.aut.notFound': 'प्राधिकार नहीं मिला',
  'dat.aut.notFoundDesc': 'हो सकता है इसे किसी अन्य शीर्षक में मर्ज कर दिया गया हो या हटा दिया गया हो।',
  'dat.aut.loadFailed': 'हम यह प्राधिकार लोड नहीं कर सके',
  'dat.aut.marcTitle': 'MARC प्राधिकार रिकॉर्ड',
  'dat.aut.marcDesc': '1XX शीर्षक, 4XX देखें-से और 5XX यह-भी-देखें अनुरेखण के साथ।',
  'dat.aut.chip.remove': '{value} हटाएँ',
  'dat.aut.create.open': 'नया प्राधिकार',
  'dat.aut.create.title': 'नया प्राधिकार',
  'dat.aut.create.description': 'वैकल्पिक रूपों के साथ नियंत्रित शीर्षक जोड़ें।',
  'dat.aut.create.submit': 'प्राधिकार बनाएँ',
  'dat.aut.edit.title': 'प्राधिकार संपादित करें',
  'dat.aut.edit.description': 'बदला गया शीर्षक हर जुड़े रिकॉर्ड में अपडेट होता है।',
  'dat.aut.form.type': 'प्राधिकार प्रकार',
  'dat.aut.form.typePlaceholder': 'प्रकार चुनें',
  'dat.aut.form.typeRequired': 'प्राधिकार प्रकार चुनें।',
  'dat.aut.form.heading': 'शीर्षक',
  'dat.aut.form.headingHint': 'उदाहरण: "Tagore, Rabindranath, 1861-1941"।',
  'dat.aut.form.headingRequired': 'शीर्षक दर्ज करें।',
  'dat.aut.form.headingLong': 'शीर्षक अधिकतम 500 अक्षरों का हो सकता है।',
  'dat.aut.form.chipsHint': 'हर मान जोड़ने के लिए Enter या अर्धविराम दबाएँ।',
  'dat.aut.form.seeFromPlaceholder': 'वैकल्पिक रूप जोड़ें',
  'dat.aut.form.seeAlsoPlaceholder': 'संबंधित शीर्षक जोड़ें',
  'dat.aut.delete.title': 'यह प्राधिकार हटाएँ?',
  'dat.aut.delete.desc': '"{heading}" हटा दिया जाएगा। किसी रिकॉर्ड में इसका उपयोग नहीं है।',
  'dat.aut.delete.usedTitle': 'यह प्राधिकार {count} रिकॉर्ड में उपयोग में है',
  'dat.aut.delete.usedDesc': 'हटाने पर हर रिकॉर्ड से लिंक हट जाएगा। उन रिकॉर्ड के शीर्षक पाठ के रूप में रहेंगे।',
  'dat.aut.delete.force': 'फिर भी हटाएँ',
  'dat.aut.linked.heading': 'जुड़े ग्रंथसूची रिकॉर्ड',
  'dat.aut.linked.description': 'सूची रिकॉर्ड से {count} लिंक।',
  'dat.aut.linked.title': 'शीर्षक',
  'dat.aut.linked.author': 'लेखक',
  'dat.aut.linked.field': 'फ़ील्ड',
  'dat.aut.linked.id': 'रिकॉर्ड आईडी',
  'dat.aut.linked.emptyTitle': 'कोई जुड़ा रिकॉर्ड नहीं',
  'dat.aut.linked.emptyDesc': 'रिकॉर्ड तब जुड़ते हैं जब उनका शीर्षक मेल खाता है या आप सूची संपादक में यह प्राधिकार चुनते हैं।',
  'dat.aut.linked.unlink': '{title} को अनलिंक करें',
  'dat.aut.linked.unlinkShort': 'अनलिंक करें',
  'dat.aut.linked.unlinked': 'रिकॉर्ड अनलिंक किया गया',
  'dat.aut.linked.confirmTitle': 'यह रिकॉर्ड अनलिंक करें?',
  'dat.aut.linked.confirmDesc': '"{title}" का {tag} शीर्षक अब इस प्राधिकार की ओर संकेत नहीं करेगा।',
  'dat.aut.merge.open': 'चुने हुए मर्ज करें',
  'dat.aut.merge.pickTwo': 'मर्ज के लिए 2 या अधिक चुनें',
  'dat.aut.merge.title': 'प्राधिकार मर्ज करें',
  'dat.aut.merge.description': 'दोहराए गए शीर्षकों को एक में मिलाएँ। सभी जुड़े रिकॉर्ड बचे हुए शीर्षक पर चले जाते हैं।',
  'dat.aut.merge.stepSurvivor': 'बचने वाला',
  'dat.aut.merge.stepPreview': 'समीक्षा',
  'dat.aut.merge.stepDone': 'पूर्ण',
  'dat.aut.merge.pickLegend': 'कौन सा शीर्षक बचा रहे?',
  'dat.aut.merge.linked': '{count} रिकॉर्ड',
  'dat.aut.merge.seeFromCount': '{count} देखें-से',
  'dat.aut.merge.review': 'मर्ज की समीक्षा करें',
  'dat.aut.merge.confirm': '{count} प्राधिकार मर्ज करें',
  'dat.aut.merge.survivor': 'बचा रहने वाला शीर्षक',
  'dat.aut.merge.willAbsorb': 'समाहित होने वाले शीर्षक: {count}',
  'dat.aut.merge.willRelink': 'स्थानांतरित होने वाले रिकॉर्ड लिंक',
  'dat.aut.merge.resultingSeeFrom': 'बचे हुए शीर्षक को ये देखें-से संदर्भ मिलेंगे',
  'dat.aut.merge.irreversible': 'मर्ज को पूर्ववत नहीं किया जा सकता। समाहित प्राधिकार हटा दिए जाते हैं।',
  'dat.aut.merge.doneTitle': 'प्राधिकार मर्ज हो गए',
  'dat.aut.merge.statMerged': 'मर्ज किए',
  'dat.aut.merge.statRelinked': 'लिंक स्थानांतरित',
  'dat.aut.merge.statRecords': 'रिकॉर्ड अपडेट',
  'dat.aut.merge.openSurvivor': 'बचा हुआ प्राधिकार खोलें',
  'dat.aut.cleanup.open': 'सफ़ाई',
  'dat.aut.cleanup.title': 'अनुपयोगी प्राधिकार साफ़ करें',
  'dat.aut.cleanup.description': 'वे प्राधिकार हटाएँ जिनसे कोई सूची रिकॉर्ड नहीं जुड़ा।',
  'dat.aut.cleanup.intro': 'पहले पूर्वावलोकन चलाएँ। सफ़ाई लागू करने तक कुछ नहीं हटता।',
  'dat.aut.cleanup.preview': 'पूर्वावलोकन',
  'dat.aut.cleanup.apply': '{count} अनुपयोगी हटाएँ',
  'dat.aut.cleanup.none': 'हर प्राधिकार कम से कम एक रिकॉर्ड से जुड़ा है। साफ़ करने को कुछ नहीं।',
  'dat.aut.cleanup.found': '{count} अनुपयोगी प्राधिकार मिले',
  'dat.aut.cleanup.foundHint': 'सफ़ाई लागू करने पर ये स्थायी रूप से हट जाएँगे।',
  'dat.aut.cleanup.done': '{count} अनुपयोगी प्राधिकार हटाए गए',
  'dat.aut.autolink.open': 'ऑटो-लिंक',
  'dat.aut.autolink.title': 'शीर्षक ऑटो-लिंक करें',
  'dat.aut.autolink.description': 'रिकॉर्ड शीर्षकों को प्राधिकारों से मिलाएँ और नए शीर्षकों के लिए प्राधिकार बनाएँ।',
  'dat.aut.autolink.intro': 'यह हर सूची रिकॉर्ड को स्कैन करता है; बड़े संग्रह में कुछ समय लग सकता है।',
  'dat.aut.autolink.running': 'शीर्षक जोड़े जा रहे हैं। यह विंडो खुली रखें।',
  'dat.aut.autolink.run': 'ऑटो-लिंक चलाएँ',
  'dat.aut.autolink.again': 'फिर चलाएँ',
  'dat.aut.autolink.processed': 'स्कैन किए रिकॉर्ड',
  'dat.aut.autolink.linked': 'बने लिंक',
  'dat.aut.autolink.created': 'बने प्राधिकार',
  'dat.aut.picker.label': 'प्राधिकार सुझाव',
  'dat.aut.picker.searching': 'खोज रहे हैं',
  'dat.aut.picker.failed': 'सुझाव लोड नहीं हो सके। आप फिर भी शीर्षक टाइप कर सकते हैं।',
  'dat.aut.picker.none': 'कोई मेल खाता प्राधिकार नहीं। आपका टाइप किया पाठ जैसा है वैसा उपयोग होगा।',
};
